/* Only progressively enhanced editorial interactions. Commerce is handled by Dawn. */
class VasudhaCarousel extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.dots = [...this.querySelectorAll('[data-dot]')];
    this.index = 0;
    this.paused = this.dataset.autoplay !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches;
    const opts = { signal: this.abort.signal };
    this.addEventListener('click', (event) => {
      const button = event.target.closest('button');
      if (!button) return;
      if (button.hasAttribute('data-next')) this.manualShow(this.index + 1);
      if (button.hasAttribute('data-prev')) this.manualShow(this.index - 1);
      if (button.hasAttribute('data-dot')) this.manualShow(Number(button.dataset.dot));
      if (button.hasAttribute('data-pause')) {
        this.paused = !this.paused;
        this.updatePause();
        this.schedule();
      }
    }, opts);
    this.addEventListener('touchstart', (event) => {
      this.touchStartX = event.changedTouches[0]?.clientX ?? 0;
    }, { ...opts, passive: true });
    this.addEventListener('touchend', (event) => {
      const endX = event.changedTouches[0]?.clientX ?? this.touchStartX;
      const delta = endX - this.touchStartX;
      if (Math.abs(delta) < 45) return;
      this.manualShow(delta < 0 ? this.index + 1 : this.index - 1);
    }, { ...opts, passive: true });
    this.addEventListener('mouseenter', () => clearTimeout(this.timer), opts);
    this.addEventListener('mouseleave', () => this.schedule(), opts);
    this.addEventListener('focusin', () => clearTimeout(this.timer), opts);
    this.addEventListener('focusout', () => this.schedule(), opts);
    document.addEventListener('visibilitychange', () => this.schedule(), opts);
    document.addEventListener('shopify:block:select', (event) => {
      const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
      if (index >= 0) { this.paused = true; this.show(index); this.updatePause(); clearTimeout(this.timer); }
    }, opts);
    this.show(this.index);
    this.updatePause();
    this.schedule();
  }
  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.hidden = false;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
    });
    this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
  }
  manualShow(index) {
    this.paused = true;
    this.show(index);
    this.updatePause();
    this.schedule();
  }
  updatePause() {
    const button = this.querySelector('[data-pause]');
    if (button) { button.textContent = this.paused ? 'Play' : 'Pause'; button.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow'); }
  }
  schedule() {
    clearTimeout(this.timer);
    if (this.paused || this.slides.length < 2 || document.hidden || this.matches(':focus-within') || this.matches(':hover')) return;
    this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.delay) || 6000);
  }
  disconnectedCallback() { clearTimeout(this.timer); this.abort.abort(); }
}
class VasudhaVideo extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.querySelector('button')?.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const id = button.dataset.video;
      if (!/^[a-zA-Z0-9_-]{11}$/.test(id || '')) return;
      const frame = document.createElement('iframe');
      frame.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1`;
      frame.title = button.getAttribute('aria-label');
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.allowFullscreen = true;
      button.replaceWith(frame);
      frame.focus();
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort.abort(); }
}
if (!customElements.get('vf-carousel')) customElements.define('vf-carousel', VasudhaCarousel);
if (!customElements.get('vf-video')) customElements.define('vf-video', VasudhaVideo);


;(() => {
  function addVasudhaWhatsapp() {
    if (document.querySelector('.vf-whatsapp-float')) return;
    const a = document.createElement('a');
    a.className = 'vf-whatsapp-float';
    a.href = 'https://wa.me/916302634723';
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'Chat with Vasudha Foods on WhatsApp');
    a.innerHTML = '<svg aria-hidden="true" viewBox="0 0 32 32"><path d="M16 3.2A12.8 12.8 0 0 0 3.2 16c0 2.3.6 4.5 1.7 6.4L3.2 28.8l6.7-1.7A12.8 12.8 0 1 0 16 3.2Zm0 23.2c-1.9 0-3.8-.5-5.5-1.5l-.4-.2-4 1 1.1-3.9-.3-.4A10.5 10.5 0 1 1 16 26.4Zm5.8-7.9c-.3-.2-1.9-.9-2.2-1-.3-.1-.5-.2-.7.2-.2.3-.9 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.4-.5-2.6-1.6-1-.8-1.6-1.9-1.8-2.2-.2-.3 0-.5.1-.7l.5-.6c.2-.2.2-.3.3-.5.1-.2.1-.4 0-.6-.1-.2-.7-1.8-1-2.4-.3-.6-.5-.5-.7-.6h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.7s1.2 3.1 1.3 3.3c.2.2 2.3 3.5 5.6 4.9.8.3 1.4.5 1.9.7.8.2 1.5.2 2.1.1.6-.1 1.9-.8 2.2-1.5.3-.7.3-1.4.2-1.5-.1-.1-.3-.2-.6-.4Z"/></svg>';
    Object.assign(a.style, {position:'fixed',right:'22px',bottom:'22px',zIndex:'999',width:'58px',height:'58px',display:'grid',placeItems:'center',borderRadius:'999px',background:'#25d366',color:'#fff',boxShadow:'0 12px 28px rgba(32,53,38,.22)'});
    const s = a.querySelector('svg');
    if (s) Object.assign(s.style, {width:'32px',height:'32px',fill:'currentColor'});
    if (matchMedia('(max-width: 749px)').matches) { Object.assign(a.style,{right:'16px',bottom:'18px',width:'52px',height:'52px'}); if(s) Object.assign(s.style,{width:'29px',height:'29px'}); }
    document.body.appendChild(a);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', addVasudhaWhatsapp, {once:true}) : addVasudhaWhatsapp();
})();
